import { NgModule } from '@angular/core';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProfileBarComponent } from './components/profile-bar/profile-bar.component';
import { RegistrationApprovalPromptComponent } from './components/registration-approval-prompt/registration-approval-prompt.component';
import { WorkshopRegistrationRequestCardComponent } from './components/workshop-registration-request-card/workshop-registration-request-card.component';
import { WorkshopRegistrationRequestRowCardComponent } from './components/workshop-registration-request-row-card/workshop-registration-request-row-card.component';
import { WorkshopRowCardComponent } from './components/workshop-row-card/workshop-row-card.component';
import { MyUpcomingWorkshopListComponent } from './components/my-upcoming-workshop-list/my-upcoming-workshop-list.component';
import {
  DxCheckBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxTextAreaModule,
} from 'devextreme-angular';
import { WorkshopCardComponent } from '../features/workshop/components/workshop-card/workshop-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { WorkshopRegisterComponent } from '../features/workshop/components/workshop-register/workshop-register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxoLoadingIndicatorModule } from 'devextreme-angular/ui/nested';
import { PastWorkshopCardComponent } from './components/past-workshop-card/past-workshop-card.component';
import { ArabicNumberDirective } from './directives/arabic-num-converter.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DateToJalaliPipe } from './pipes/date-to-jalali.pipe';
import { StringToDatePipe } from './pipes/string-to-date.pipe';
import { ExtractHtmlTextPipe } from './pipes/extract-html-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { PersianTimePipe } from './pipes/persian-time.pipe';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import {
  lucideUser,
  lucideCalendar,
  lucideLayers,
  lucideMapPin,
  lucideUserPlus,
  lucideHourglass,
  lucideBan,
  lucideUserCheck,
  lucidePlus,
  lucideClock,
  lucideUserCircle,
  lucideFileText,
  lucideLoader2,
  lucidePaperclip,
  lucideSquare,
} from '@ng-icons/lucide';

@NgModule({
  declarations: [
    AccessDeniedComponent,
    PageNotFoundComponent,
    ProfileBarComponent,
    RegistrationApprovalPromptComponent,
    WorkshopRegistrationRequestCardComponent,
    WorkshopRegistrationRequestRowCardComponent,
    WorkshopRowCardComponent,
    MyUpcomingWorkshopListComponent,
    WorkshopCardComponent,
    WorkshopRegisterComponent,
    PastWorkshopCardComponent,
    ArabicNumberDirective,
    ClickOutsideDirective,
    DateToJalaliPipe,
    StringToDatePipe,
    ExtractHtmlTextPipe,
    SafeHtmlPipe,
    PersianTimePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DxTabPanelModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxCheckBoxModule,
    DxoLoadingIndicatorModule,
    NgIconsModule,
  ],
  providers: [
    provideIcons({
      lucideUser,
      lucideCalendar,
      lucideLayers,
      lucideMapPin,
      lucideUserPlus,
      lucideHourglass,
      lucideBan,
      lucideUserCheck,
      lucidePlus,
      lucideClock,
      lucideUserCircle,
      lucideFileText,
      lucideLoader2,
      lucidePaperclip,
      lucideSquare,
    }),
  ],
  exports: [
    AccessDeniedComponent,
    PageNotFoundComponent,
    ProfileBarComponent,
    RegistrationApprovalPromptComponent,
    WorkshopRegistrationRequestRowCardComponent,
    WorkshopRegistrationRequestCardComponent,
    WorkshopRowCardComponent,
    MyUpcomingWorkshopListComponent,
    WorkshopCardComponent,
    WorkshopRegisterComponent,
    PastWorkshopCardComponent,
    ArabicNumberDirective,
    ClickOutsideDirective,
    DateToJalaliPipe,
    StringToDatePipe,
    ExtractHtmlTextPipe,
    SafeHtmlPipe,
    PersianTimePipe,
  ],
})
export class SharedModule {}
